
















































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';
import {Inject} from 'inversify-props';

import {CertificateIssuerDetails} from '@/model/system/certificate/certificateIssuerDetails';
import {CertificateGenerationParameters} from '@/model/system/certificate/certificateGenerationParameters';
import {CertificateDetails} from '@/model/system/certificate/certificateDetails';

import {ISystemCertificateService} from '@/services/system/ICertificate.service';
import {Certificate} from '@fidm/x509';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class CertificateGenerate extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ISystemCertificateService'))
  private systemCertificateService!: ISystemCertificateService;

  @Prop()
  private activeCertificate!: CertificateDetails;

  private certificate: Certificate | null = null;

  private newIssuerDetails: CertificateIssuerDetails = new CertificateIssuerDetails();

  private parameters: CertificateGenerationParameters = new CertificateGenerationParameters({
    Validity: 30,
    Dnss: [],
    KeyLength: 2048,
    Passphrase: '',
  });

  private domains: string[] = [];
  private domainsInput: string = '';

  private generationFormValid: boolean = true;

  private validityDurationRules = [
    (value: string) => !!value || 'required',
    (value: string) => Number.isInteger(Number(value)) || 'must be a integer number',
    (value: string) => +value <= 825 || 'must be smaller than 2 year (825 days)',
  ];

  private validationRulesCN = [
    (value: string) => !!value || 'required',
    (value: string) => !value.includes('_') || 'cannot include underscores "_"',
  ];

  private validationRulesC = [
    (value: string) => value.length === 2 || 'must be two letters',
  ];

  private generating: boolean = false;

  private mounted() {
    this.updateCertificate();
  }

  @Watch('activeCertificate')
  private updateCertificate() {
    Object.assign(this.newIssuerDetails, this.activeCertificate.IssuerDetails);

    this.certificate = Certificate.fromPEM(Buffer.from(this.activeCertificate.Content, 'utf-8'));
    Object.assign(this.domains, this.certificate.dnsNames);
  }


  private updateTags() {
    this.$nextTick(() => {
      if (this.domainsInput) {
        this.domains.push(...this.domainsInput.split(','));
        this.$nextTick(() => {
          this.domainsInput = '';
        });
      }
    });
  }

  private quickUpdateTags() {
    if (this.domainsInput && this.domainsInput.includes(',')) {

      const terms = this.domainsInput.split(',');
      this.domains.push(...terms.splice(0, terms.length - 1));

      this.$nextTick(() => {
        this.domainsInput = terms[0];
      });
    }
  }

  private async generate() {

    const generationForm = this.$refs.generationForm as Vue & { validate: () => boolean };

    if (generationForm.validate()) {
      try {
        this.generating = true;

        if (this.domains.length > 0) {
          this.parameters.Dnss = this.domains;
        }
        const newCertificate = await this.systemCertificateService.generate(this.parameters, this.newIssuerDetails);

        this.logger.info('New certificate generated', newCertificate);
        Notify.Success(this.logger, `The certificate has been generated<br>Restart the Manager daemon to use the new certificate`);
        this.$emit('update:certificate', newCertificate);
      } catch (error) {
        Notify.Error(this.logger, `Could not generate certificate`, error);
      } finally {
        this.generating = false;
      }
    }
  }
}
